import Sidemenu from "../layout/sidemenu";
import Header from "../layout/header";
import React, { useState, useEffect } from "react";
import { Formik } from 'formik';
import { toast } from "react-toastify";
import ErrorMessage from "../components/ErrorMessage";
import { NoAuthApiRequest, ApiRequest } from "./services/apiservice";
import { ApiEndpoints, ApiEndpointMethod } from "../utils/endpoints";
import { useNavigate } from "react-router";
import { addClient } from "../utils/schema";
import { Tooltip } from 'react-tooltip';
import Loader from './shared/loader'

const Effortestimatedetail = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [loader, setloader] = useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        ClientId: '',
        Name: '',
        Id: 0,
        UserId: -1,
        Description: '',
        EstimateHours: 0,
        StartDate: null,
        EndDate: null,
        StatusId: null,
        TypeId: null,
        Comments: ''
    });
    const [search, setsearch] = useState('');
    const [lstClient, setlstClient] = useState([]);
    const [lstTimeZone, setlstTimeZone] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50); // Default page size
    const [totalPages, setTotalPages] = useState(0);

    const [startCount, setstartCount] = useState("");
    const [endCount, setendCount] = useState("");
    const [totalCount, settotalCount] = useState("");
    const [lstProject, setlstProject] = useState([]);

    useEffect(() => {

        const fetchData = async () => {
            await FetchTimeZone();
            await FetchClient();
            await fetchProjectList();
        };
        fetchData();

    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name == "EstimateHours") {
            if (value === "" || value.length <= 3) {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: value
                }));
            }
        }
        else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }
        if (name == "StartDate") {

            if (value > formData.EndDate) {
                setFormData((prevState) => ({
                    ...prevState,
                    ["EndDate"]: ""
                }));
            }
        }
    };

    const FetchTimeZone = async () => {
        const data = await ApiRequest(
            ApiEndpoints.Entity.FetchTimeZone,
            ApiEndpointMethod.Get,
            null,
            navigate
        );
        setlstTimeZone(data);
    };

    const FetchClient = async () => {
        const data = await ApiRequest(
            ApiEndpoints.Entity.FetchClient,
            ApiEndpointMethod.Get,
            null,
            navigate
        );
        setlstClient(data);
    };

    const formatDate = (date) => {

        if (date != null) {
            const utcDateString = date.endsWith('Z') ? date : `${date}Z`;
            const localDate = new Date(utcDateString);  // Convert ISO string to Date object
            return localDate.toLocaleDateString(); // Or customize further as needed
        }
        else {
            return "";
        }
    };

    const formatDateUTC = (date) => {

        if (date != null) {
            const utcDateString = date.indexOf('T') > -1 ? date.split('T')[0] : `${date}Z`;
            const localDate = new Date(utcDateString);  // Convert ISO string to Date object
            return localDate.toLocaleDateString(); // Or customize further as needed
        }
        else {
            return "";
        }
    };

    const formatDateUTCDate = (dateString) => {
        if (dateString != "" && dateString != undefined && dateString != null) {
            const date = new Date(dateString);

            // Adjust to local time
            const month = date.getMonth() + 1; // Months are zero-indexed
            const day = date.getDate();
            const year = date.getFullYear();

            return `${month}/${day}/${year}`;
        }
        else {
            return '';
        }
    }

    const formatDateUTCDateTime = (dateString) => {

        if (dateString != "" && dateString != undefined && dateString != null) {
            const date = new Date(dateString);

            // Adjust to local time
            const month = date.getMonth() + 1; // Months are zero-indexed
            const day = date.getDate();
            const year = date.getFullYear();
            return `${year}-${n(month)}-${n(day)}`;
        }
        else {
            return null;
        }
    }

    const n = (n) => {
        return n > 9 ? "" + n : "0" + n;
    }


    const fetchProjectList = async () => {

        await fetchProjects(1, pageSize);
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchProjects(page, pageSize);
    };


    const handleKeyPress = async (event) => {
        // Check if the pressed key is Enter (keyCode 13)
        if (event.key === 'Enter') {
            await fetchProjects(1, pageSize);
            // You can trigger any logic here when Enter is pressed
        }
    };

    const handleChanges = (event) => {
        setsearch(event.target.value);
    };

    const fetchProjects = async (page, limit) => {

        try {
            // setLoader(true);

            setloader(true);
            const data = await ApiRequest(ApiEndpoints.Entity.FetchProjectList(page, limit, search), ApiEndpointMethod.Get, null, navigate);


            await setlstProject(data.Item1);
            const totalPages = Math.ceil(data.Item2 / limit);
            setTotalPages(totalPages);

            const startcount = Math.ceil(
                Math.ceil(Math.ceil(page * limit) - limit) + 1
            );
            let endcount = Math.ceil(page * limit);
            if (endcount > data.Item2) {
                endcount = Math.ceil(endcount - Math.ceil(endcount - data.Item2));
            }
            setstartCount(startcount);
            setendCount(endcount);
            settotalCount(data.Item2);

            return { data };
            // Handle the response data here (e.g., show success message or update UI)
        } catch (error) {
            console.error("Error during API call:", error);
            // await setfileList([]);
            // Handle errors (e.g., show an error message to the user)
        }
        finally {
            setloader(false);
            ///   setLoader(false);
        }
    };

    const getPageNumbers = () => {
        // Dynamically generate page numbers
        const pageNumbers = [];
        let startPage = Math.max(1, currentPage - 1);  // Prevent going below 1
        let endPage = Math.min(totalPages, currentPage + 1);  // Prevent going above totalPages

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const handleChangeTigger = (name, value) => {

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const ClearField = async () => {
        await handleChangeTigger("ClientId", '');
        await handleChangeTigger("Name", '');
        await handleChangeTigger("Id", 0);
        await handleChangeTigger("Description", '');
        await handleChangeTigger("EstimateHours", 0);
        await handleChangeTigger("StartDate", '');
        await handleChangeTigger("EndDate", '');
        await handleChangeTigger("StartDate", null);
        await handleChangeTigger("EndDate", null);
        await handleChangeTigger("UserId", -1);
        await handleChangeTigger("StatusId", '');
        await handleChangeTigger("TypeId", '');
        await handleChangeTigger("Comments", '');


    }

    const EditProject = async (projectId) => {
        setloader(true);
        document.getElementById('mdlAddProject').click();

        const data = await ApiRequest(ApiEndpoints.Entity.GetProjectDetails(projectId), ApiEndpointMethod.Get, navigate);
        if (data != null) {


            await handleChangeTigger("ClientId", data.ClientId);
            await handleChangeTigger("Name", data.Name);
            await handleChangeTigger("Id", data.Id);
            await handleChangeTigger("Description", data.Description);
            await handleChangeTigger("EstimateHours", data.EstimateHours);
            // await handleChangeTigger("StartDate", formatDateUTCDateTime(data.StartDate));
            // await handleChangeTigger("EndDate", formatDateUTCDateTime(data.EndDate));
            await handleChangeTigger("StatusId", data.StatusId);
            await handleChangeTigger("TypeId", data.TypeId);
            await handleChangeTigger("Comments", data.Comments);


            //alert(data);
        }
        setloader(false);
    }

    const CreateProject = async (validateForm, setTouched, values) => {
        try {

            const errors = await validateForm();

            // if (Object.keys(errors).length === 0) {
            if (formData.ClientId <= 0) {
                toast.error("Please select the client", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if (formData.Name == "" || formData.Name == undefined || formData.Name == null) {
                toast.error("Please enter the project name", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if (formData.TypeId == "" || formData.TypeId == undefined || formData.TypeId == null) {
                toast.error("Please select the project type", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if (formData.StatusId == "" || formData.StatusId == undefined || formData.StatusId == null) {
                toast.error("Please select the Status type", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            setloader(true);
            const usrDetails = JSON.parse(localStorage.getItem("user"));
            formData.UserId = usrDetails.Id;
            const data = await ApiRequest(ApiEndpoints.Entity.CreateProject, ApiEndpointMethod.Post, formData, navigate);
            if (data.success == true) {

                fetchProjects(currentPage, pageSize);
                document.getElementById('btnc').click();
                toast.success(data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                await ClearField();
            }
            else {
                toast.error(data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }

        } catch (error) {
            // Handle network errors or any other errors
            console.error("There was an error sending the form data", error);
            toast.success(error, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        finally {
            setloader(false);
        }

    };

    const typeLabels = {
        1: 'Fixed',
        2: 'Billable',
        3: 'Support'
    };

    const statusLabels = {
        1: 'Active',
        2: 'InActive',
        3: 'Completed',
        4: 'Hold'
    };

    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0" style={{ marginRight: "5px" }}>Project Details</h5>


                            <input className="form-control me-2" placeholder="search..." onChange={handleChanges} onKeyDown={handleKeyPress} value={search} type="search" style={{ width: '220px' }} />
                        </div>

                        <div className="row">
                            <div className="col-lg-4">
                                
                            </div>

                            <div className="col-lg-8">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" id="fixed-tab" data-bs-toggle="tab" data-bs-target="#fixed" type="button"
                                            role="tab" aria-controls="fixed" aria-selected="true">Fixed / Support</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="billable-tab" data-bs-toggle="tab" data-bs-target="#billable" type="button"
                                            role="tab" aria-controls="billable" aria-selected="false">Billable</button>
                                    </li>
                                    {/* <li class="nav-item" role="presentation">
                                                                <button class="nav-link" id="support-tab" data-bs-toggle="tab" data-bs-target="#support" type="button"
                                                                    role="tab" aria-controls="support" aria-selected="false">Support</button>
                                                            </li> */}
                                </ul>

                                <div class="tab-content border-top-0 bg-lite shadow-sm" id="myTabContent">
                                    <div class="tab-pane fade show active table-wrapper tab-table" id="fixed" role="tabpanel" aria-labelledby="fixed-tab">
                                        <table className="table table-striped table-bordered bg-white mb-0">
                                            <thead>
                                                <tr>
                                                    <th width="30%">Project Name</th>
                                                    <th width="15%">Start Date</th>
                                                    <th width="15%">Last Timesheet entry</th>
                                                    <th width="13%">Estimated Hours</th>
                                                    <th width="12%">Used Hours</th>
                                                    <th width="15%">Utilized Percentage</th>
                                                    {/* <th width="15%">Status</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                    <td>50%</td>
                                                </tr>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                    <td>50%</td>
                                                </tr>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                    <td>50%</td>
                                                </tr>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                    <td>50%</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="tab-pane fade" id="billable" role="tabpanel" aria-labelledby="billable-tab">
                                        <table className="table table-sm table-bordered bg-white mb-0">
                                            <thead>
                                                <tr>
                                                    <th width="30%">Project Name</th>
                                                    <th width="15%">Start Date</th>
                                                    <th width="15%">Last Timesheet entry</th>
                                                    <th width="15%">Estimated Hours</th>
                                                    <th width="15%">Used Hours</th>
                                                    {/* <th width="15%">Utilized Percentage</th>
                                                                            <th width="15%">Status</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                </tr>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                </tr>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                </tr>
                                                <tr>
                                                    <td>Test</td>
                                                    <td>05/11/2025</td>
                                                    <td>05/11/2025</td>
                                                    <td>50</td>
                                                    <td>25</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div class="tab-pane fade" id="support" role="tabpanel" aria-labelledby="support-tab">
                                                                Support
                                                            </div> */}
                                </div>
                            </div>
                        </div>


                        <div className="card-header">
                            <div className="col-lg-4 border-end border-lite">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0">Project Users</h5>
                                </div>
                                <div className="list-group list-group-start">

                                    <div className={`list-group-item d-flex justify-content-between`}>
                                        <p className="mb-0">Person 1</p>
                                        <div className="text-nowrap">
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">active</span>
                                        </div>
                                    </div>
                                    <div className={`list-group-item d-flex justify-content-between`}>
                                        <p className="mb-0">Person 2</p>
                                        <div className="text-nowrap">
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">active</span>
                                        </div>
                                    </div>
                                    <div className={`list-group-item d-flex justify-content-between`}>
                                        <p className="mb-0">Person 3</p>
                                        <div className="text-nowrap">
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">active</span>
                                        </div>
                                    </div>
                                    <div className={`list-group-item d-flex justify-content-between`}>
                                        <p className="mb-0">Person 4</p>
                                        <div className="text-nowrap">
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">active</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default Effortestimatedetail;